export default __webpack_public_path__ + "static/media/ts4.e9e9ee8b.png";